(function () {
  function money(cents) {
    var format =
      (window.theme && theme.strings && theme.strings.moneyFormat) || '{{amount}}';
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, format);
    }
    return String(cents);
  }

  function sizedImage(url) {
    if (!url) return '';
    return url.replace(/(\.[^.]*)$/, '_300x$1').replace('http:', '');
  }

  function enhanceDrawer(cart) {
    if (!cart || !cart.item_count) return;
    var rows = document.querySelectorAll('#CartDrawer .ajaxcart__row');
    cart.items.forEach(function (item, index) {
      var row = rows[index];
      if (!row) return;
      var img = row.querySelector('.ajaxcart__product-image img');
      if (img && item.image) img.src = sizedImage(item.image);
      var unit = row.querySelector('.ajaxcart__unit');
      if (!unit) return;
      if (item.original_price !== item.final_price) {
        unit.innerHTML = '<s>' + money(item.original_price) + '</s> ' + money(item.final_price);
      } else {
        unit.textContent = money(item.final_price);
      }
    });
  }

  function templateImage(url) {
    if (!url) {
      return '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
    }
    return url.replace(/(\.[^.]*)$/, '_small$1').replace('http:', '');
  }

  function visibleProperties(properties) {
    var copy = {};
    if (!properties) return copy;
    Object.keys(properties).forEach(function (key) {
      var value = properties[key];
      if (key.charAt(0) === '_' || !value) return;
      copy[key] = value;
    });
    return copy;
  }

  function renderFromCart(cart) {
    var container = document.getElementById('CartContainer');
    var sourceEl = document.getElementById('CartTemplate');
    if (!container || !cart || !sourceEl || !window.Handlebars) return;

    if (!cart.item_count) {
      var emptyText = (window.theme && theme.strings && theme.strings.cartEmpty) || '';
      var cookieText = (window.theme && theme.strings && theme.strings.cartCookies) || '';
      container.innerHTML =
        '<p class="cart--empty-message">' +
        emptyText +
        '</p>' +
        (cookieText ? '<p class="cookie-message">' + cookieText + '</p>' : '');
      return;
    }

    var items = (cart.items || []).map(function (cartItem, index) {
      var allocations = cartItem.line_level_discount_allocations || [];
      return {
        key: cartItem.key,
        line: index + 1,
        url: cartItem.url,
        img: templateImage(cartItem.image),
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        sellingPlanAllocation: cartItem.selling_plan_allocation,
        properties: visibleProperties(cartItem.properties),
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: money(cartItem.original_line_price),
        discountedPrice: money(cartItem.final_line_price),
        discounts: allocations.map(function (discount) {
          return {
            discount_application: discount.discount_application,
            formattedAmount: money(discount.amount),
          };
        }),
        discountsApplied: allocations.length > 0,
      };
    });
    var cartDiscounts = (cart.cart_level_discount_applications || []).map(function (discount) {
      return {
        title: discount.title,
        formattedAmount: money(discount.total_allocated_amount),
      };
    });

    container.innerHTML = Handlebars.compile(sourceEl.innerHTML)({
      items: items,
      note: cart.note,
      totalPrice: money(cart.total_price),
      cartDiscounts: cartDiscounts,
      cartDiscountsApplied: cartDiscounts.length > 0,
    });
    enhanceDrawer(cart);
    syncCheckoutButton(document.querySelector('#CartDrawer .ajaxcart__checkout'), cart);
  }

  document.addEventListener('cart:refresh', function (event) {
    var cart = event.detail && event.detail.cart;
    try {
      if (cart) renderFromCart(cart);
      else loadCartIntoDrawer();
    } catch (e) {}
  });

  if (window.jQuery) {
    window.jQuery(document.body).on('ajaxCart.afterCartLoad', function (_evt, cart) {
      enhanceDrawer(cart);
      syncCheckoutButton(document.querySelector('#CartDrawer .ajaxcart__checkout'), cart);
    });
  }

  function isAddonOnlyCart(cart) {
    var items = (cart && cart.items) || [];
    var seen = false;
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (!item || !(Number(item.quantity) > 0)) continue;
      seen = true;
      var addon = item.cpt26_addon === true || String(itemProps(item)._cpt26_addon || '') === '1';
      if (!addon) return false;
    }
    return seen;
  }

  function syncCheckoutButton(button, cart) {
    if (!button) return;
    var locked = isAddonOnlyCart(cart);
    button.disabled = locked;
    button.setAttribute('aria-disabled', locked ? 'true' : 'false');
  }

  function shopRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function itemProps(item) {
    var props = item && item.properties;
    return props && typeof props === 'object' && !Array.isArray(props) ? props : {};
  }

  function isAddonItem(item) {
    return String(itemProps(item)._cpt26_addon || '') === '1';
  }

  function isBogoGiftItem(item) {
    if (!item || isAddonItem(item)) return false;
    var props = itemProps(item);
    var keys = Object.keys(props);
    for (var i = 0; i < keys.length; i++) {
      var key = String(keys[i]).toLowerCase();
      var value = String(props[keys[i]] == null ? '' : props[keys[i]]).toLowerCase();
      if (key.indexOf('bogos') !== -1 || value.indexOf('bogos') !== -1) return true;
    }
    if (String(item.vendor || '').toLowerCase() === 'freegifts') return true;
    var handle = String(item.handle || '').toLowerCase();
    return handle.indexOf('freegift') !== -1 || handle.indexOf('sca_clone') !== -1;
  }

  function linkedCleanupUpdates(cart) {
    var updates = {};
    if (!cart || !cart.items) return updates;
    var realVariants = {};
    cart.items.forEach(function (item) {
      if (!item || item.quantity <= 0 || isAddonItem(item) || isBogoGiftItem(item)) return;
      realVariants[String(item.variant_id)] = true;
    });
    var hasRealProduct = Object.keys(realVariants).length > 0;
    cart.items.forEach(function (item) {
      if (!item || !item.key) return;
      if (isAddonItem(item)) {
        var parent = String(itemProps(item)._cpt26_parent || '');
        if (!parent || !realVariants[parent]) updates[item.key] = 0;
        return;
      }
      if (!hasRealProduct && isBogoGiftItem(item)) updates[item.key] = 0;
    });
    return updates;
  }

  var linkedCleanupTimer = null;
  function scheduleLinkedCleanup() {
    clearTimeout(linkedCleanupTimer);
    linkedCleanupTimer = setTimeout(function () {
      window.fetch(shopRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          var updates = linkedCleanupUpdates(cart);
          if (!Object.keys(updates).length) return null;
          return window.fetch(shopRoot() + 'cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ updates: updates })
          });
        })
        .catch(function () {});
    }, 600);
  }

  function postCartUpdates(updates) {
    return nativeFetch(shopRoot() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    });
  }

  function stripOrphanAddons(res) {
    if (!res || !res.ok || typeof res.clone !== 'function') return Promise.resolve(res);
    return res
      .clone()
      .json()
      .then(function (cart) {
        var updates = linkedCleanupUpdates(cart);
        if (!Object.keys(updates).length) return res;
        return postCartUpdates(updates).then(function (nextRes) {
          scheduleLinkedCleanup();
          return nextRes && nextRes.ok ? nextRes : res;
        });
      })
      .catch(function () {
        return res;
      });
  }

  function loadCartIntoDrawer() {
    fetch(shopRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (!cart || cart.status) return;
        renderFromCart(cart);
      })
      .catch(function () {});
  }

  function openRealDrawer() {
    var btn = document.querySelector('button.js-drawer-open-button-right');
    if (window.jQuery && btn) {
      window.jQuery(btn).trigger('click');
      return;
    }
    if (btn) {
      btn.click();
      return;
    }
    if (window.timber && timber.RightDrawer && typeof timber.RightDrawer.open === 'function') {
      timber.RightDrawer.open({
        preventDefault: function () {},
        stopPropagation: function () {},
      });
    }
  }

  var nativeFetch = window.fetch;
  var addOpenTimer = null;
  var skipDrawerUntil = 0;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url ? input.url : '';
    var isAdd = /\/cart\/add(\.js|\.json)?(\?|$)/.test(url);
    var isChange = /\/cart\/change(\.js|\.json)?(\?|$)/.test(url);
    var isClear = /\/cart\/clear\.js(\?|$)/.test(url);
    if (isClear) skipDrawerUntil = Date.now() + 5000;
    var href = location.href;
    return nativeFetch.apply(this, arguments).then(function (res) {
      var ready = isChange ? stripOrphanAddons(res) : Promise.resolve(res);
      return ready.then(function (finalRes) {
      if (isAdd && finalRes && finalRes.ok && Date.now() >= skipDrawerUntil) {
        clearTimeout(addOpenTimer);
        addOpenTimer = setTimeout(function () {
          if (location.href !== href) return;
          if (/\/checkouts?(\/|$|\?)/.test(location.pathname)) return;
          if (!document.body.classList.contains('js-drawer-open-right')) openRealDrawer();
          else loadCartIntoDrawer();
        }, 400);
      }
      return finalRes;
      });
    });
  };

  var drawerWasOpen = document.body.classList.contains('js-drawer-open-right');
  new MutationObserver(function () {
    var open = document.body.classList.contains('js-drawer-open-right');
    if (open && !drawerWasOpen) loadCartIntoDrawer();
    drawerWasOpen = open;
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('#CartDrawer .ajaxcart__remove');
    if (!btn || btn.disabled) return;
    event.preventDefault();
    var line = btn.getAttribute('data-line');
    if (!line) return;
    btn.disabled = true;
    fetch(shopRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: 0 }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (!cart || cart.status) {
          btn.disabled = false;
          return;
        }
        renderFromCart(cart);
      })
      .catch(function () {
        btn.disabled = false;
      });
  });

  var overlay = document.getElementById('CartDrawerOverlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.id = 'CartDrawerOverlay';
    overlay.className = 'cart-drawer-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    document.body.appendChild(overlay);
  }
  overlay.addEventListener('click', function () {
    var closeBtn = document.querySelector('#CartDrawer .js-drawer-close');
    if (closeBtn) closeBtn.click();
  });

  var drawer = document.getElementById('CartDrawer');
  var legalModal = document.querySelector('[data-drawer-legal-modal]');
  if (drawer && legalModal) {
    function setLegalOpen(open) {
      legalModal.hidden = !open;
      document.body.style.overflow = open ? 'hidden' : '';
    }

    drawer.addEventListener('click', function (event) {
      if (!event.target.closest('[data-drawer-legal-open]')) return;
      event.preventDefault();
      setLegalOpen(true);
    });

    legalModal.addEventListener('click', function (event) {
      if (event.target.closest('[data-drawer-legal-close]')) setLegalOpen(false);
    });

    document.addEventListener(
      'keydown',
      function (event) {
        if ((event.key === 'Escape' || event.keyCode === 27) && !legalModal.hidden) {
          event.stopPropagation();
          setLegalOpen(false);
        }
      },
      true
    );
  }

  if (window.ShopifyAPI && typeof ShopifyAPI.changeItem === 'function' && !ShopifyAPI.changeItem.__cpt26Addon) {
    var originalChangeItem = ShopifyAPI.changeItem;
    var wrappedChangeItem = function (line, quantity, callback) {
      return originalChangeItem.call(ShopifyAPI, line, quantity, function (cart) {
        var updates = linkedCleanupUpdates(cart);
        if (!Object.keys(updates).length) {
          if (typeof callback === 'function') callback(cart);
          return;
        }
        scheduleLinkedCleanup();
        postCartUpdates(updates)
          .then(function (res) {
            return res.json();
          })
          .then(function (next) {
            if (typeof callback === 'function') callback(next && next.items ? next : cart);
          })
          .catch(function () {
            if (typeof callback === 'function') callback(cart);
          });
      });
    };
    wrappedChangeItem.__cpt26Addon = true;
    ShopifyAPI.changeItem = wrappedChangeItem;
  }
})();
